"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadProcessing = void 0;
var UploadProcessing = /** @class */ (function () {
    function UploadProcessing(uuid, fileSize, options, uploadAdapter, eventEmitter) {
        this.uuid = uuid;
        this.fileSize = fileSize;
        this.options = options;
        this.uploadAdapter = uploadAdapter;
        this.eventEmitter = eventEmitter;
    }
    /**
     * Event listener
     */
    UploadProcessing.prototype.on = function (event, callback) {
        this.eventEmitter.on(event, callback);
        return this;
    };
    /**
     * Cancel upload
     */
    UploadProcessing.prototype.cancel = function () {
        this.uploadAdapter.cancel(this.uuid);
    };
    /**
     * Pause upload (works only on uploading state!!!)
     */
    UploadProcessing.prototype.pause = function () {
        this.uploadAdapter.pause();
    };
    /**
     * Resume upload
     */
    UploadProcessing.prototype.resume = function () {
        this.uploadAdapter.resume();
    };
    /**
     * Get uuid of upload
     */
    UploadProcessing.prototype.getUuid = function () {
        return this.uuid;
    };
    return UploadProcessing;
}());
exports.UploadProcessing = UploadProcessing;
//# sourceMappingURL=UploadProcessing.js.map